import {
    ESharedFunction,
    ESharedFunctionMultiple,
} from "motw_core/Enums/ESharedFunction";
import { ESharedComponent } from "./ESharedComponent";

export const State = (function () {
    const sharedClassStates: {
        [componentName: string]: SharedClassState<any>;
        // | SharedFunctionState<any>;
    } = {};

    const sharedFunctionStates: {
        [componentName: string]: SharedFunctionState<any>;
    } = {};

    // TODO: ReadClass could return undefined, so add that as a return type
    function ReadClass<S>(component: ESharedComponent): SharedClassState<S> {
        const componentName = ESharedComponent[component];

        const sharedClassState: SharedClassState<S> =
            sharedClassStates[componentName];

        return sharedClassState;
    }

    function ReadFunction<S>(name: ESharedFunction): SharedFunctionState<S> {
        const stateName = ESharedFunction[name];

        const sharedFunctionState: SharedFunctionState<S> =
            sharedFunctionStates[stateName];

        return sharedFunctionState;
    }

    function ShareClass<S>(
        key: ESharedComponent,
        component: React.Component<{}, S>,
        additionalData?: any
    ) {
        var name = ESharedComponent[key];
        var foundSharedComponent =
            Object.values(ESharedComponent).includes(name);

        if (!foundSharedComponent) {
            throw new Error(
                `The component ${name} is not registered as a shared component. Check the enum ESharedComponent.`
            );
        }

        if (!sharedClassStates[name]) {
            sharedClassStates[name] = {} as SharedClassState<S>;
        }

        sharedClassStates[name] = {
            additionalData,
            state: Object.assign(
                {},
                sharedClassStates[name].state,
                component.state
            ),
            setState: (newState: any, callback?: () => any) => {
                // Use to debug setState calls on a component
                // console.log(
                // 	`${name} has had its state set to ${JSON.stringify(
                // 		newState
                // 	)}`
                // );

                const BoundSetStateFunction =
                    component.setState.bind(component);

                BoundSetStateFunction(newState, callback);
            },
        } as SharedClassState<S>;
    }

    function ShareFunction<S>(
        name: ESharedFunction,
        state: S,
        setState: React.Dispatch<React.SetStateAction<S>>
    ) {
        var funcName = ESharedFunction[name];

        if (!sharedClassStates[funcName]) {
            sharedClassStates[funcName] = {} as SharedClassState<S>;
        }

        sharedFunctionStates[funcName] = {
            state,
            setState,
        } as SharedFunctionState<S>;
    }

    function ShareFunctionMultiple<S>(
        name: ESharedFunctionMultiple,
        uniqueKey: string,
        state: S,
        setState: React.Dispatch<React.SetStateAction<S>>
    ) {
        var funcName = `${ESharedFunctionMultiple[name]}_${uniqueKey}`;

        if (!sharedClassStates[funcName]) {
            sharedClassStates[funcName] = {} as SharedClassState<S>;
        }

        sharedFunctionStates[funcName] = {
            state,
            setState,
        } as SharedFunctionState<S>;
    }

    function ReadFunctionMultiple<S>(
        name: ESharedFunctionMultiple,
        uniqueKey: string
    ): SharedFunctionState<S> {
        var funcName = `${ESharedFunctionMultiple[name]}_${uniqueKey}`;

        const sharedFunctionState: SharedFunctionState<S> =
            sharedFunctionStates[funcName];

        return sharedFunctionState;
    }

    return {
        ReadClass,
        ReadFunction,
        ReadFunctionMultiple,
        ShareClass,
        ShareFunction,
        ShareFunctionMultiple,
    };
})();

export interface SharedClassState<S> {
    additionalData: any;
    state: S;
    setState: <K extends keyof S>(
        state: Partial<Pick<S, K>>,
        callback?: () => any
    ) => void;
}

interface SharedFunctionState<S> {
    additionalData: any;
    state: S;
    setState: React.Dispatch<React.SetStateAction<S>>;
}
